import React from "react";
import { Box, Heading, Image, Paragraph, ResponsiveContext } from "grommet";
import Photo from "../../../../images/management/poselenov-2.jpg";
import { BIOGRAPHY } from "../../../../mocks/management";
export var CardWithImage = function CardWithImage() {
  return /*#__PURE__*/ React.createElement(
    "div",
    null,
    /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
      return /*#__PURE__*/ React.createElement(
        Box,
        null,
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            direction: size === "small" ? "column" : "row",
            background: {
              color: "site-colors-1",
            },
            round: "20px",
            width: "max-content",
            pad: "medium",
            gap: "medium",
          },
          /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              width: {
                max: size !== "small" ? "300px" : "350px",
              },
              height: "356px",
              margin: {
                bottom: "medium",
              },
            },
            /*#__PURE__*/ React.createElement(Image, {
              fit: "cover",
              src: Photo,
              style: {
                borderRadius: "16px",
              },
            })
          )
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          null,
          /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              color: "light",
              gap: "small",
              pad: {
                left: "small",
              },
            },
            /*#__PURE__*/ React.createElement(
              Heading,
              {
                level: 3,
                size: "large",
                style: {
                  textTransform: "uppercase",
                },
              },
              "Поселёнов Павел Александрович"
            ),
            /*#__PURE__*/ React.createElement(
              Paragraph,
              {
                size: "small",
                fill: true,
                style: {
                  textTransform: "uppercase",
                },
              },
              "Президент Федерации триатлона Москвы"
            ),
            BIOGRAPHY.map(function (bio) {
              return /*#__PURE__*/ React.createElement(
                Paragraph,
                {
                  size: "small",
                  fill: true,
                },
                bio.value
              );
            })
          )
        )
      );
    })
  );
};
